// const defaultConfigName = 'global-ceping-doctor-dev'; // 测评医生端正式环境
// const defaultConfigName = 'global-ceping-doctor-test'; // 测评医生端测试环境
const defaultConfigName = 'global-ceping-doctor-prod'; // 测评医生端正式环境
module.exports = defaultConfigName;
